import React, { useEffect, useState } from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

const AnimatedProgressBar = ({ 
  value, 
  duration = 1500,
  className = '',
  barClassName = ''
}) => {
  const [ref, isVisible] = useScrollAnimation(0.3);
  const [width, setWidth] = useState(0);

  useEffect(() => {
    if (!isVisible) return;

    // Small delay before starting animation
    const timeout = setTimeout(() => {
      setWidth(value);
    }, 100);

    return () => clearTimeout(timeout);
  }, [isVisible, value]);

  return (
    <div ref={ref} className={`h-3 bg-stone-100 rounded-full overflow-hidden ${className}`}>
      <div 
        className={`h-full rounded-full transition-all ease-out ${barClassName}`}
        style={{ 
          width: `${width}%`,
          transitionDuration: `${duration}ms`
        }}
      />
    </div>
  );
};

export default AnimatedProgressBar;
